import React from "react"
import Grid from "@mui/material/Grid"
import TextField from "@mui/material/TextField"
import FormError from "../form-error/form-error.component"
import { withStyles } from "@mui/styles"

const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "white",
    },
    "& label": {
      color: "white",
    },

    "& input": {
      color: "white",
    },

    "& .MuiInput-underline:before": {
      borderBottomColor: "white",
    },

    "& .MuiInput-underline:after": {
      borderBottomColor: "white",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "white",
      },
      "&:hover fieldset": {
        borderColor: "white",
      },
      "&.Mui-focused fieldset": {
        borderColor: "white",
      },
    },
  },
})(TextField)

const CustomTextField = ({
  halfWidth,
  name,
  register,
  type,
  label,
  isRequired,
  errors,
  customError,
  multiline,
  rowsMax,
  minLength,
}) => {
  return (
    <Grid item xs={12} sm={halfWidth ? 6 : 12}>
      <CssTextField
        color="primary"
        required={!!isRequired}
        type={type ? type : "text"}
        multiline={!!multiline}
        rowsMax={rowsMax}
        name={name}
        inputRef={
          register
            ? register({
                required: !!isRequired,
                minLength: {
                  value: minLength,
                  message: customError,
                },
              })
            : ""
        }
        fullWidth
        label={label}
      />
      {errors[name] && (
        <FormError
          errorMessage={customError ? customError : "This is a required field"}
        />
      )}
    </Grid>
  )
}
export default CustomTextField
